import React, { useState, useEffect } from "react";
import { Container, Card, Table, Button, Form, Modal, Row, Col } from "react-bootstrap";
import api from "../../services/api";

const jenisPelatihanOptions = [
  { kode: "PPH01", nama: "Pelatihan Penyelia Halal UMK Self Declare" },
  { kode: "PPH02", nama: "Pelatihan Penyelia Halal UMK Reguler" },
  { kode: "PPH03", nama: "Pelatihan Penyelia Halal Reguler" },
];

const JadwalPelatihanR41 = () => {
  const [jadwalList, setJadwalList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    tgl_mulai: "",
    tgl_selesai: "",
    jenis_pelatihan: "",
    angkatan: "",
    biaya: "",
  });

  useEffect(() => {
    fetchJadwal();
  }, []);

  const fetchJadwal = async () => {
    try {
      const response = await api.get("/jadwal-pelatihan");
      setJadwalList(response.data);
    } catch (error) {
      console.error("Error fetching jadwal:", error);
    }
  };

  const handleShowModal = (jadwal = null) => {
    if (jadwal) {
      setEditingId(jadwal.id);
      setFormData({
        tgl_mulai: jadwal.tgl_mulai ? jadwal.tgl_mulai.split("T")[0] : "",
        tgl_selesai: jadwal.tgl_selesai ? jadwal.tgl_selesai.split("T")[0] : "",
        jenis_pelatihan: jadwal.jenis_pelatihan || "",
        angkatan: jadwal.angkatan || "",
        biaya: jadwal.biaya || "",
      });
    } else {
      setEditingId(null);
      setFormData({
        tgl_mulai: "",
        tgl_selesai: "",
        jenis_pelatihan: "",
        angkatan: "",
        biaya: "",
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        ...formData,
        biaya: parseFloat(formData.biaya) || 0,
      };

      if (editingId) {
        await api.put(`/jadwal-pelatihan/${editingId}`, data);
      } else {
        await api.post("/jadwal-pelatihan", data);
      }
      handleCloseModal();
      fetchJadwal();
    } catch (error) {
      console.error("Error saving jadwal:", error);
      alert("Gagal menyimpan data");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus jadwal ini?")) {
      try {
        await api.delete(`/jadwal-pelatihan/${id}`);
        fetchJadwal();
      } catch (error) {
        console.error("Error deleting jadwal:", error);
        alert("Gagal menghapus data");
      }
    }
  };

  const formatTanggal = (tgl) => {
    if (!tgl) return "-";
    const date = new Date(tgl);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("id-ID", options);
  };

  const getJenisPelatihanNama = (kode) => {
    const found = jenisPelatihanOptions.find((j) => j.kode === kode);
    return found ? found.nama : kode;
  };

  return (
    <Container fluid>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Jadwal Pelatihan</h5>
          <Button variant="primary" onClick={() => handleShowModal()}>
            <i className="fas fa-plus me-2"></i>
            Tambah Jadwal
          </Button>
        </Card.Header>
        <Card.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>No</th>
                <th>Jenis Pelatihan</th>
                <th>Angkatan</th>
                <th>Tanggal Mulai</th>
                <th>Tanggal Selesai</th>
                <th>Biaya</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {jadwalList.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    Tidak ada data jadwal
                  </td>
                </tr>
              ) : (
                jadwalList.map((jadwal, index) => (
                  <tr key={jadwal.id}>
                    <td>{index + 1}</td>
                    <td>{getJenisPelatihanNama(jadwal.jenis_pelatihan)}</td>
                    <td>{jadwal.angkatan || "-"}</td>
                    <td>{formatTanggal(jadwal.tgl_mulai)}</td>
                    <td>{formatTanggal(jadwal.tgl_selesai)}</td>
                    <td>
                      {jadwal.biaya
                        ? new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            minimumFractionDigits: 0,
                          }).format(jadwal.biaya)
                        : "-"}
                    </td>
                    <td>
                      <Button
                        variant="warning"
                        size="sm"
                        className="me-2"
                        onClick={() => handleShowModal(jadwal)}
                      >
                        <i className="fas fa-edit"></i>
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDelete(jadwal.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Modal Form */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {editingId ? "Edit Jadwal Pelatihan" : "Tambah Jadwal Pelatihan"}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Jenis Pelatihan</Form.Label>
                  <Form.Select
                    value={formData.jenis_pelatihan}
                    onChange={(e) =>
                      setFormData({ ...formData, jenis_pelatihan: e.target.value })
                    }
                    required
                  >
                    <option value="">Pilih Jenis Pelatihan</option>
                    {jenisPelatihanOptions.map((option) => (
                      <option key={option.kode} value={option.kode}>
                        {option.nama}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Angkatan</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.angkatan}
                    onChange={(e) =>
                      setFormData({ ...formData, angkatan: e.target.value })
                    }
                    placeholder="Contoh: Angkatan 1 - 2024"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Mulai</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.tgl_mulai}
                    onChange={(e) =>
                      setFormData({ ...formData, tgl_mulai: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tanggal Selesai</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.tgl_selesai}
                    onChange={(e) =>
                      setFormData({ ...formData, tgl_selesai: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Biaya (Rp)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.biaya}
                    onChange={(e) =>
                      setFormData({ ...formData, biaya: e.target.value })
                    }
                    placeholder="0"
                    min="0"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Batal
            </Button>
            <Button variant="primary" type="submit">
              Simpan
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default JadwalPelatihanR41;
